// src/store/store.js
import { configureStore } from '@reduxjs/toolkit';
import homeReducer from './slices/client/clientHomeSlice'; // Assuming you have a client home slice
import authReducer from './slices/authSlice';
import ordersReducer from './slices/ordersSlice';
import productsReducer from './slices/productsSlice';
import dashboardReducer from './slices/dashboardSlice';
import paymentsReducer from './slices/paymentsSlice';
import shippingReducer from './slices/shippingSlice';
import adminsReducer from './slices/adminsSlice';
import usersReducer from './slices/usersSlice';
import templatesReducer from './slices/templatesSlice';
import analyticsReducer from './slices/analyticsSlice';
import adminSideBarReducer from './slices/adminSideBarSlice'; // Assuming you have a sidebar slice

import contactUsReducer from './slices/contactUsSlice';
import designReducer from './slices/designSlice';
import clientOrderAndPaymentReducer from './slices/client/clientOrderAndPaymentSlice'; // Assuming you have a checkout slice
import UserOrdersReducer from './slices/client/clientOrderSlice'; // Assuming you have a checkout slice
// Additional User slices (adjust import paths as necessary)
import eventCelebrationGiftsReducer from './slices/user/eventCelebrationGiftsSlice';
import ledLampsReducer from './slices/user/ledLampsSlice';
import usbDrivesReducer from './slices/user/usbDrivesSlice';
import wallArtPhotoPrintsReducer from './slices/user/wallArtPhotoPrintsSlice';
// import weddingInvitationPartySuppliesReducer from './slices/user/weddingInvitationPartySuppliesSlice';
// import woodenClocksReducer from './slices/user/woodenClocksSlice';
// import totebagsBackpacksReducer from './slices/user/totebagsBackpacksSlice';
// import jewelleryReducer from './slices/user/jewellerySlice';
import cartReducer from './slices/user/cartSlice'; // Assuming you have a cart slice

import clientCategoryReducer from './slices/client/clientProductSlice';
import favoritesReducer from './slices/user/favoritesSlice'; // Assuming you have a favorites slice
import giftCardsReducer from './slices/user/giftCardsSlice'; // Assuming you have a gift cards slice
import hampersReducer from './slices/user/hampersSlice'; // Assuming you have a hampers slice
import homelivingReducer from './slices/user/homelivingSlice'; // Assuming you have a home living slice
// import homeReducer from './slices/user/homeSlice'; // Assuming you have a home slice
import hoodiesSweatshirtsReducer from './slices/user/hoodiesSweatshirtsSlice'; // Assuming you have a hoodies and sweatshirts slice
import keychainsReducer from './slices/user/keychainsSlice'; // Assuming you have a keychains slice
import mugsReducer from './slices/user/mugsSlice'; // Assuming you have a mugs slice
// import orderHistoryReducer from './slices/user/orderHistorySlice'; // Assuming you have an order history slice
import paymentReducer from './slices/user/paymentSlice'; // Assuming you have a payment slice
import techOfficeProductsReducer from './slices/user/techOfficeProductsSlice'; // Assuming you have a tech office products slice
import couponReducer from './slices/couponSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    orders: ordersReducer,
    products: productsReducer,
    payments: paymentsReducer,
    shipping: shippingReducer,
    admins: adminsReducer,
    clientOrderAndPayment: clientOrderAndPaymentReducer,
    users: usersReducer,
    templates: templatesReducer,
    analytics: analyticsReducer,
    dashboard: dashboardReducer,
    contactUs: contactUsReducer,
    coupon: couponReducer,


    homeDetail: homeReducer,
    eventCelebrationGifts: eventCelebrationGiftsReducer,
    ledLamps: ledLampsReducer,
    usbDrives: usbDrivesReducer,
    wallArtPhotoPrints: wallArtPhotoPrintsReducer,
   
    // woodenClocks: woodenClocksReducer,
    // totebagsBackpacks: totebagsBackpacksReducer,
    // jewellery: jewelleryReducer,
    cart: cartReducer,
    design: designReducer,
    productByCategory: clientCategoryReducer,
    favorites: favoritesReducer,
    giftCards: giftCardsReducer,
    hampers: hampersReducer,
    homeliving: homelivingReducer,
    home: homeReducer,
    hoodiesSweatshirts: hoodiesSweatshirtsReducer,
    keychains: keychainsReducer,
    mugs: mugsReducer,
    userOrder: UserOrdersReducer,
    payment: paymentReducer,
    techOfficeProducts: techOfficeProductsReducer,
    sidebar: adminSideBarReducer,


  },
});
